import type { Proposal, SeniorityLevel } from "@/features/Dashboard";

export const SENIORITY_ORDER: SeniorityLevel[] = ["Junior", "Pleno", "Senior"];

export function getProposalColorClasses(heatLevel: Proposal["heatLevel"]) {
  const colorMap = {
    frozen: "bg-blue-100 text-blue-800",
    cold: "bg-blue-100 text-blue-800",
    cool: "bg-blue-100 text-blue-800",
    warm: "bg-yellow-100 text-yellow-800",
    hot: "bg-orange-100 text-orange-800",
    burning: "bg-red-100 text-red-800",
  };

  return colorMap[heatLevel] || "bg-gray-100 text-gray-800";
}

export function formatProposalDate(dateString?: string): string {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("pt-BR");
}

export function calculateResourcesByType(
  resourceForecast: Record<string, any>
) {
  return Object.values(resourceForecast).reduce(
    (total: number, resource: any) => total + resource.total,
    0
  );
}

export function formatSeniorityDisplay(seniority: string): string {
  return seniority.charAt(0).toUpperCase() + seniority.slice(1);
}
